<script>
    export let data;

    import {Tile,Button, Modal, DatePicker, DatePickerInput} from "carbon-components-svelte";
    import ShareKnowledge20 from "carbon-icons-svelte/lib/ShareKnowledge20";
    import { updateTask} from "../store";
    import EnumStatus from "../services/taskstatus";
	const theme = {
		calendar: {
			width: '800px',
			shadow: '0px 0px 5px rgba(0, 0, 0, 0.25)'
		}
	};

    function updateTaskDelegated() {
        //Set Delegated
        data.status = EnumStatus.DELEGATED; //EnumStatus.SCHEDULED
        //Select Who
        //Select followup date
        const date = new Date(duedate);
        data.nextaction = date;

        updateTask(data)
        open = false;
    }


    let duedate = new Date();
    duedate.setDate(duedate.getDate() + 7);

    let open = false;
    let newdelegateto;
    //let taskid = data.id;
</script>

<!-- Button trigger modal -->
<Button kind="ghost" iconDescription="Delegate" on:click={() => (open = true)} icon={ShareKnowledge20}
></Button
>

<!-- Modal -->
<Modal
bind:open
modalHeading="Delegate Task"
primaryButtonText="Delegate"
secondaryButtonText="Cancel"
on:click:button--secondary={() => (open = false)}
hasForm:true
on:open
on:close
on:submit={updateTaskDelegated}
min-height:309rem
>
   <form>
        <div class="form-floating mb-3">
            <input
                bind:value={newdelegateto}
                type="text"
                class="form-control"
                id="thoughtInput"
                placeholder="action"
                
            />
            <label for="thoughtInput">Who</label>
        </div>
<!-- <InlineCalendar on:submit {theme} bind:selected={duedate} /> -->
<Tile>
<DatePicker datePickerType="single" bind:value={duedate} on:change flatpickrProps={{ static: true, position: "right", dateFormat: "Y-m-d" }} min-height:100vh>
    <DatePickerInput labelText="Defer Until Date" placeholder="Y-m-d" />
  </DatePicker>
</Tile>
</form>

</Modal>